var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTeams(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12750_213635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1586 5.97656H15.2914C15.6819 5.97656 15.9984 6.31564 15.9984 6.73385V10.7661C15.9984 12.3031 14.8351 13.5492 13.4001 13.5492H13.3877C11.9527 13.5494 10.7893 12.3036 10.7891 10.7665V6.37241C10.789 6.32043 10.7986 6.26895 10.8171 6.22091C10.8357 6.17288 10.8629 6.12923 10.8972 6.09247C10.9315 6.05571 10.9723 6.02655 11.0171 6.00666C11.062 5.98677 11.11 5.97654 11.1586 5.97656Z",
    fill: "#5059C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9518 5.18083C14.8765 5.18083 15.6262 4.37783 15.6262 3.38729C15.6262 2.39675 14.8765 1.59375 13.9518 1.59375C13.027 1.59375 12.2773 2.39675 12.2773 3.38729C12.2773 4.37783 13.027 5.18083 13.9518 5.18083Z",
    fill: "#5059C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74284 5.18132C10.0786 5.18132 11.1615 4.02144 11.1615 2.59066C11.1615 1.15988 10.0786 0 8.74284 0C7.40707 0 6.32422 1.15988 6.32422 2.59066C6.32422 4.02144 7.40707 5.18132 8.74284 5.18132Z",
    fill: "#7B83EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.97 5.97656H5.14806C4.76225 5.98681 4.45706 6.32977 4.466 6.74302V11.342C4.41213 13.8219 6.24381 15.8799 8.559 15.9406C10.8742 15.8799 12.7059 13.8219 12.6521 11.342V6.74302C12.661 6.32977 12.3558 5.98681 11.97 5.97656Z",
    fill: "#7B83EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.93022 5.97656V12.4213C8.92933 12.5658 8.88859 12.7069 8.81313 12.8267C8.73766 12.9466 8.63083 13.0399 8.50604 13.0949C8.42479 13.1317 8.33747 13.1507 8.24929 13.1507H4.79247C4.7441 13.0191 4.69947 12.8876 4.66222 12.7521C4.53197 12.2948 4.46552 11.8193 4.46504 11.3412V6.74182C4.4561 6.32923 4.76079 5.98681 5.14597 5.97663L8.93022 5.97656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.55797 5.97656V12.8199C8.55797 12.9143 8.54029 13.0079 8.50591 13.0949C8.45453 13.2286 8.36743 13.343 8.25555 13.4238C8.14367 13.5047 8.01199 13.5483 7.87704 13.5492H4.96735C4.9041 13.4177 4.84454 13.2862 4.79247 13.1507C4.74245 13.0204 4.69897 12.8874 4.66222 12.7521C4.53197 12.2948 4.46552 11.8193 4.46504 11.3412V6.74182C4.4561 6.32923 4.76079 5.98681 5.14597 5.97663L8.55797 5.97656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.55803 5.97656V12.0228C8.55522 12.4243 8.25204 12.7491 7.8771 12.7521H4.66222C4.53197 12.2948 4.46552 11.8193 4.46504 11.3412V6.74182C4.4561 6.32923 4.76079 5.98681 5.14597 5.97663L8.55803 5.97656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.18597 5.97656V12.0228C8.1831 12.4243 7.87991 12.7491 7.50504 12.7521H4.66222C4.53197 12.2948 4.46552 11.8193 4.46504 11.3412V6.74182C4.4561 6.32923 4.76079 5.98681 5.14597 5.97663L8.18597 5.97656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.92831 3.91687V5.1723C8.86506 5.17632 8.8055 5.18034 8.74225 5.18034C8.679 5.18034 8.61944 5.17632 8.55619 5.1723C8.4306 5.16338 8.30605 5.14204 8.18413 5.10857C7.81266 5.01434 7.46729 4.82726 7.17627 4.56265C6.88524 4.29803 6.65682 3.96339 6.50969 3.58609C6.45831 3.45756 6.41845 3.3241 6.39062 3.1875H8.24738C8.62281 3.18904 8.92688 3.51466 8.92831 3.91687Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.55816 4.31524V5.17215C8.43257 5.16322 8.30802 5.14188 8.18609 5.10841C7.81464 5.01417 7.46929 4.82709 7.17827 4.56248C6.88726 4.29787 6.65885 3.96323 6.51172 3.58594H7.87722C8.25272 3.58741 8.55672 3.9131 8.55816 4.31524Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.55816 4.31524V5.17215C8.43257 5.16322 8.30802 5.14188 8.18609 5.10841C7.81464 5.01417 7.46929 4.82709 7.17827 4.56248C6.88726 4.29787 6.65885 3.96323 6.51172 3.58594H7.87722C8.25272 3.58741 8.55672 3.9131 8.55816 4.31524Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.18616 4.31531V5.10848C7.81469 5.01424 7.46932 4.82716 7.17829 4.56253C6.88726 4.2979 6.65885 3.96325 6.51172 3.58594H7.50522C7.88072 3.58748 8.18472 3.91317 8.18616 4.31531Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.682063 3.586H7.50394C7.88069 3.586 8.18606 3.9131 8.18606 4.31658V11.6238C8.18606 12.0272 7.88069 12.3543 7.504 12.3543H0.682063C0.305375 12.3543 0 12.0272 0 11.6238V4.31665C0 3.91303 0.305375 3.586 0.682063 3.586Z",
    fill: "url(#paint0_linear_12750_213635)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.88681 6.36537H4.52306V10.343H3.65425V6.36537H2.29688V5.59375H5.88681V6.36537Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12750_213635",
    x1: 142.208,
    y1: -53.4963,
    x2: 733.328,
    y2: 902.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A62C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4D55BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12750_213635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTeams);
export default __webpack_public_path__ + "static/media/icon_teams.6134c7dfd1afd8f1b801502f0948b906.svg";
export { ForwardRef as ReactComponent };